import React, { Component } from 'react'
import AccountMenu from '../Modules/AccountMenu'
import { Button } from 'react-bootstrap'
import Kennis from '../Modules/Rapport/Kennis'
import KennisOnbekend from '../Modules/Rapport/KennisOnbekend'
import PersoonlijkeGegevens from '../Modules/Rapport/PersoonlijkeGegevens'
import TotaalPunten from '../Modules/Rapport/TotaalPunten'
import TotaalTelling from '../Modules/Rapport/TotaalTelling'
import Referenten from '../Modules/Rapport/Referenten'
import Werkervaring from '../Modules/Rapport/Werkervaring'
import Api from './../../Global/Modules/Api'
import Docentschappen from '../Modules/Rapport/Docentschappen';
import Publicaties from '../Modules/Rapport/Publicaties';
import Lidmaatschappen from '../Modules/Rapport/Lidmaatschappen';
import Voordrachten from '../Modules/Rapport/Voordrachten';
import Bijeenkomsten from '../Modules/Rapport/Bijeenkomsten';
import KennisIncompany from '../Modules/Rapport/KennisIncompany';

const FETCH_URL = "api/members/report"
class RapportBekijken extends Component {
    constructor(props) {
        super(props)
        this.getReport = this.getReport.bind(this)
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            data: {},
            member: {}
        }
    }
    handleClick(e) {
        var url = "api/members/" + this.state.data.member.id + "/pdf";
        Api.GetApiDownload(url)
    }
    getReport() {
        Api.GetApi(FETCH_URL).then(data => {
            this.setState({ data })
            this.setState({ member: data.member })
        })
    }

    componentWillMount() {
        this.getReport()
    }




    render() {
        let data = this.state.data
        let member = data.member
        let permanent = this.state.member.status
        let completeName = member ? `${member.title == null ? '' : member.title} ${member.initials == null ? '' : member.initials} ${member.firstName == null ? '' : member.firstName} ${member.middleName == null ? '' : member.middleName} ${member.lastName == null ? '' : member.lastName}` : null
        let educations = data.educations
        let workingExperiences = data.workingExperiences
        let workingExperiencesP = data.workingExperiencesP
        return (
            <div className="route">
                <AccountMenu />
                <div className="grey-bg">
                    <h1 className="pageTitle">
                        Rapport
                    </h1>
                    <strong>{completeName}</strong>
                    <p>{data ? Api.formatDate(data.reportDate) : null}</p>
                    <p className="text-left"><Button onClick={this.handleClick}>Printen</Button></p>
                </div>

                <div className="grey-bg">
                    <TotaalPunten data={data.header} />
                </div>

                <div className="grey-bg">
                    <PersoonlijkeGegevens data={member} />
                </div>

                <div className="grey-bg">
                    <Kennis data={educations ? educations.educationsKnown : null} permanent={false} />
                </div>

                {/** NEW TABLE **/}
                <div className="grey-bg">
                    <KennisOnbekend data={educations ? educations.educationsUnknown : null} permanent={false} />
                </div>

                {/** NEW TABLE **/}
                <div className="grey-bg">
                    <Docentschappen data={educations ? educations.educationUnknownTeacherships : null} permanent={false} />
                </div>

                {/** NEW TABLE **/}
                <div className="grey-bg">
                    <Publicaties data={educations ? educations.educationUnknownPublications : null} permanent={false} />
                </div>

                {/** NEW TABLE **/}
                <div className="grey-bg">
                    <Lidmaatschappen data={educations ? educations.educationUnknownMemberships : null} permanent={false} />
                </div>

                {/** NEW TABLE **/}
                <div className="grey-bg">
                    <Voordrachten data={educations ? educations.educationUnknownLectures : null} permanent={false} />
                </div>

                {/** NEW TABLE **/}
                <div className="grey-bg">
                    <Bijeenkomsten data={educations ? educations.educationUnknownMeetings : null} permanent={false} />
                </div>
                <div className="grey-bg">
                    <KennisIncompany data={educations ? educations.educationUnknownInCompany : null} permanent={false} />
                </div>

                <div className="grey-bg">
                    <Referenten data={data.references} />
                </div>

                <div className="grey-bg">
                    <Werkervaring data={workingExperiences} />
                </div>

                {permanent == "Aspirant" ? '' :
                    <div><div className="grey-bg">
                        <Kennis data={educations ? educations.educationsKnownP : null} permanent={true} />
                    </div>

                        {/** NEW TABLE **/}
                        <div className="grey-bg">
                            <KennisOnbekend data={educations ? educations.educationsUnknownP : null} permanent={true} />
                        </div>

                        {/** NEW TABLE **/}
                        <div className="grey-bg">
                            <Docentschappen data={educations ? educations.educationUnknownTeachershipsP : null} permanent={true} />
                        </div>

                        {/** NEW TABLE **/}
                        <div className="grey-bg">
                            <Publicaties data={educations ? educations.educationUnknownPublicationsP : null} permanent={true} />
                        </div>

                        {/** NEW TABLE **/}
                        <div className="grey-bg">
                            <Lidmaatschappen data={educations ? educations.educationUnknownMembershipsP : null} permanent={true} />
                        </div>

                        {/** NEW TABLE **/}
                        <div className="grey-bg">
                            <Voordrachten data={educations ? educations.educationUnknownLecturesP : null} permanent={true} />
                        </div>

                        {/** NEW TABLE **/}
                        <div className="grey-bg">
                            <Bijeenkomsten data={educations ? educations.educationUnknownMeetingsP : null} permanent={true} />
                        </div>

                        <div className="grey-bg">
                            <KennisIncompany data={educations ? educations.educationUnknownInCompanyP : null} permanent={true} />
                        </div>

                        <div className="grey-bg">
                            <Werkervaring data={workingExperiencesP} permanent={true} />
                        </div></div>
                }

                <div className="grey-bg">
                    <TotaalTelling data={workingExperiences ? workingExperiences.ofooter : null} data2={workingExperiences ? workingExperiences.cCfooter : null} />
                </div>
            </div>
        );
    }
}

export default RapportBekijken;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/RapportBekijken.js